export default {
  '操作日志': 'Action Log',
  '请输入关键字': 'Enter keywords',
  '删除选中': 'Delete selected',
  '状态': 'Status',
  '搜索': 'Search',
  '清空': 'Clear',
  '启用': 'Enable',
  '禁用': 'Disable',
  '操作': 'Tool',
  '详情': 'Detail',
  '删除': 'Delete',
  '日志详情': 'Log Info',

  'ID': 'ID',
  '账号ID': 'Passposrt ID',
  '账号昵称': 'Passposrt Nickname',
  '请求URL': 'Request URL',
  '请求IP': 'Request IP',
  '请求方式': 'Request Method',
  '请求内容': 'Request Body',
  '请求时间': 'Request Time',
  'UA信息': 'UA Info',
  '激活状态': 'Status',

  '确认要删除该日志吗？': 'Do you want to delete the log?',
  '确认要删除选中的日志吗？': 'Do you want to delete the log what you select?',
  '请选择要删除的日志': 'Pleace select log what you want to delete',
  '确认要清空一个月之前的日志吗？': 'Do you want to delete the log what they time is a month before？'
}
